import DeleteBill from "./DeleteBill";

export default DeleteBill;
